import getReduxActions from "./generate-redux/getReduxActions";
import getReduxReducers from "./generate-redux/getReduxReducers";
import getReduxTypes from "./generate-redux/getReduxTypes";

function generateReduxFiles(params, callback) {
  callback({
    reduxTypes: getReduxTypes(params),
    reduxReducers: getReduxReducers(params),
    reduxActions: getReduxActions(params),
  });
}

export default generateReduxFiles;
